/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
//import Table, { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core/Table';
import List, { ListItem, ListItemText, ListItemSecondaryAction } from '@material-ui/core/List';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import CarLogo from './CarLogo';
//import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import awsmobile from '../aws-exports';
import {API} from '@aws-amplify/core';
import { CircularProgress } from '@material-ui/core/CircularProgress';
import { removeDollarSign, formatTresCommas, capitalizeFirstLetter, formatDate } from '../helper';
import Grid from '@material-ui/core/Grid';
import Search from './Search';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import TagFacesIcon from '@material-ui/icons/TagFaces';
import CarIcon from '@material-ui/icons/DirectionsCar';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import RatingStars from './RatingStars';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import ReactGA from 'react-ga';


const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  numberCircle: {
    'border-radius': '50%',
    width: '36px',
    height: '36px',
    //padding: '6px',
    'line-height': '36px',
    background: theme.palette.primary.dark,
    border: '2px solid #fff',
    color: theme.palette.secondary.light,
    'text-align': 'center',
    'font-size': '24px',
    'font-color': '#fff'
  },
  listItem: {
    width: '100%',
    padding: '2px',
  },
  list: {
    width: '100%',
    padding: '2px',
  },
  chipRoot: {
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing.unit / 2,
  },
  chip: {
    margin: theme.spacing.unit / 2,
  },
  carImage: {
    display: 'flex',
    'max-width': 160,
    'max-height': 100,
    height: 'auto',
    width: 'auto',
    justifyContent: 'center',
  },
  carImageDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  largeIcon: {
    width: 80,
    height: 80,
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    //paddingLeft: '10px',
    //paddingTop: '5px',
    //height: '50px',
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
});

class CompareDeals extends Component{

    constructor(props) {
      super(props);
      this.handleSearchSelect = this.handleSearchSelect.bind(this);
      this.state = {
        selectedDeals: [],
        open: false,
      };

      ReactGA.initialize('UA-107081605-2');
      ReactGA.pageview(window.location.pathname + window.location.search);
    }

    handleSearchSelect(selectedDeal) {
      console.log('in handleSearchSelect. id: ' + selectedDeal.id);
      /*let chipData = [...this.state.chipData];
      chipData.push({ key: selectedDeal.id, label: selectedDeal.make + ' ' + selectedDeal.model });
      this.setState({ chipData });*/

      let selectedDeals = [...this.state.selectedDeals];
      if (selectedDeals.indexOf(selectedDeal) == -1) {
        console.log('now trying to add item: ' + selectedDeals.length);
        if (selectedDeals.length >= 2) {
          this.setState({ open: true });
          return;
        }
        selectedDeals.push(selectedDeal);
        this.setState({ selectedDeals });
      } else {
        console.log('Deal already selected.');
      }

    }

    handleDealClick = () => {
      //console.log('list item clicked');
    };

    handleDelete = data => () => {
      // if (data.label === 'React') {
      //   alert('Why would you want to delete React?! :)'); // eslint-disable-line no-alert
      //   return;
      // }

      const selectedDeals = [...this.state.selectedDeals];
      const chipToDelete = selectedDeals.indexOf(data);
      selectedDeals.splice(chipToDelete, 1);
      this.setState({ selectedDeals });
    };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ open: false });
  };


    render() {
        const { classes, allLocalDeals } = this.props;
        const { selectedDeals } = this.state;

        return (
          <div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={this.state.open}
              autoHideDuration={10000}
              onClose={this.handleClose}

              message={<span id="message-id">Only two offers can be compared. Please delete one and search to select another offer.</span>}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={classes.close}
                  onClick={this.handleClose}
                >
                  <CloseIcon />
                </IconButton>,
              ]}
            />

            <Paper className={classes.detailHeader}>
              <IconButton className={classes.contrastText} aria-label="Menu">
                <NavigateNextIcon />
              </IconButton>
              <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                COMPARE LEASE OFFERS
              </Typography>
            </Paper>

          <Grid container alignItems="stretch" justify="center" spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Paper>
                <Search onSearchSelect={this.handleSearchSelect} allLocalDeals={allLocalDeals}/>
                  <Paper className={classes.chipRoot}>
                    {this.state.selectedDeals.map(data => {
                      let avatar = null;

                      if (data.label === 'React') {
                        avatar = (
                          <Avatar>
                            <TagFacesIcon className={classes.svgIcon} />
                          </Avatar>
                        );
                      }

                      return (
                        <Chip
                          key={data.id}
                          avatar={avatar}
                          label={data.make + ' ' + data.model}
                          onDelete={this.handleDelete(data)}
                          className={classes.chip}
                        />
                      );
                    })}
                  </Paper>
              </Paper>
            </Grid>


            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            </Grid>

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>

                  <div className={classes.carImageDiv}>
                    <img src={selectedDeals[0].offerImage} className={classes.carImage} alt="" />
                  </div>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <div className={classes.carImageDiv}>
                  <CarIcon className={classes.largeIcon}/>

                </div>

              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>

                  <div className={classes.carImageDiv}>
                    <img src={selectedDeals[1].offerImage} className={classes.carImage} alt="" />
                  </div>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <div className={classes.carImageDiv}>
                  <CarIcon className={classes.largeIcon} />
                </div>

              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="title" gutterBottom align="center">

                  {capitalizeFirstLetter(selectedDeals[0].make) + ' ' + selectedDeals[0].model}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="title" gutterBottom align="center">
                  Search for a car make and model
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="title" gutterBottom align="center">


                  {capitalizeFirstLetter(selectedDeals[1].make) + ' ' + selectedDeals[1].model}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="title" gutterBottom align="center">
                  Search for a car make and model
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Lease Offer Rating
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <RatingStars valueScore={selectedDeals[0].valueScore} />
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <RatingStars valueScore={selectedDeals[1].valueScore} />
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Monthly Payment
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${removeDollarSign(selectedDeals[0].leaseMonthlyPayment)}
                </Typography>
                <Typography variant="caption" gutterBottom align="center">
                  /MONTH
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${removeDollarSign(selectedDeals[1].leaseMonthlyPayment)}
                </Typography>
                <Typography variant="caption" gutterBottom align="center">
                  /MONTH
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Lease Term
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  {selectedDeals[0].leaseMonths}
                </Typography>
                <Typography variant="caption" gutterBottom align="center">
                  MONTHS
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  {selectedDeals[1].leaseMonths}
                </Typography>
                <Typography variant="caption" gutterBottom align="center">
                  MONTHS
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Due At Signing
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[0].dueAtSigning))}
                </Typography>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[1].dueAtSigning))}
                </Typography>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Lease End Purchase
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[0].leaseEndPurchase))}
                </Typography>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[1].leaseEndPurchase))}
                </Typography>

              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  MSRP
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[0].msrp))}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${formatTresCommas(removeDollarSign(selectedDeals[1].msrp))}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Excess Mile Charge
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${removeDollarSign(selectedDeals[0].excessMileCharge)}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  ${removeDollarSign(selectedDeals[1].excessMileCharge)}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }

            <Hidden xsDown>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography variant="subheading" gutterBottom align="right">
                  Offer Expires
                </Typography>
              </Grid>
            </Hidden>
            {
            (selectedDeals[0]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  {formatDate(selectedDeals[0].leaseOfferExpiration)}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
            {
            (selectedDeals[1]) ?
              <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="body1" gutterBottom align="center">
                  {formatDate(selectedDeals[1].leaseOfferExpiration)}
                </Typography>
              </Grid>
            : <Grid item xs={6} sm={5} md={5} lg={5} xl={5}>
                <Typography variant="subheading" gutterBottom align="center">
                  -
                </Typography>
              </Grid>
            }
          </Grid>
          </div>

        );
    }
}

export default withStyles(styles)(CompareDeals);

//<div className={classes.numberCircle}>{(i+1)}</div>



// WEBPACK FOOTER //
// ./src/components/CompareDeals.jsx